import { render } from "./UrlField.vue?vue&type=template&id=5fdc59f0"
import script from "./UrlField.vue?vue&type=script&lang=js"
export * from "./UrlField.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"UrlField.vue"]])

export default __exports__